module.exports = __webpack_public_path__ + "img/teachersListEmpty.02f92bc6.png";